
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User, Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function UserProfileAuth() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  
  const handleProfileClick = () => {
    navigate('/profile');
  };
  
  const getInitials = (email: string) => {
    return email.substring(0, 2).toUpperCase();
  };

  // Determinar se o usuário fez login com Google
  const isGoogleUser = user?.app_metadata?.provider === 'google';
  
  const getDisplayName = () => {
    if (!user) return '';
    return user.user_metadata?.name || user.email || '';
  };

  return (
    <div className={`flex items-center justify-center gap-2 p-2`}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div onClick={handleProfileClick} className="cursor-pointer flex items-center">
            <Avatar className="h-9 w-9 border border-sidebar-border">
              <AvatarImage src={user?.user_metadata?.avatar_url || ""} />
              <AvatarFallback className="text-xs bg-primary text-primary-foreground">
                {user ? getInitials(user.email || "") : <User className="h-4 w-4" />}
              </AvatarFallback>
            </Avatar>
            {isGoogleUser && (
              <div className="ml-2 hidden md:block">
                <p className="text-xs text-sidebar-foreground font-medium">{getDisplayName()}</p>
                <p className="text-[10px] text-sidebar-foreground/70">Google</p>
              </div>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent align="center">
          <div className="text-center">
            <p className="font-medium">{getDisplayName()}</p>
            <p className="text-xs text-muted-foreground">Clique para editar perfil</p>
            {isGoogleUser && (
              <p className="text-xs mt-1 flex items-center justify-center">
                <Info className="h-3 w-3 mr-1" />
                Login via Google
              </p>
            )}
          </div>
        </TooltipContent>
      </Tooltip>

      {user && (
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => signOut()}
          className="rounded-full hover:bg-sidebar-accent/20"
          title="Sair"
        >
          <LogOut className="h-4 w-4 text-sidebar-foreground" />
        </Button>
      )}
    </div>
  );
}
